import {UploadDataPoint} from "../_section/DataPointForm";
import React from "react";

export default function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>

        </>
    );


}